import { getDifference } from 'Pages/ProjectPage/helpers/updatedProjectData';
import { TaskDetailToUpdate, TaskState } from 'types/store/taskDetail';
import { TASK_STATUS } from 'utils/constants';

export const compareDates = (originalDate?: string, newDate?: string) => {
  if (newDate && !originalDate) {
    return true;
  }

  if (newDate && originalDate) {
    return new Date(newDate).getTime() !== new Date(originalDate).getTime();
  }

  if (originalDate && !newDate) {
    return true;
  }

  return false;
};

export const formatDate = (date: Date | string) => {
  return new Date(date).toLocaleDateString('en-US');
};

export const getTakDetailsToUpdate: (
  originalTaskDetail: Partial<TaskState>,
  newTaskDetail: TaskDetailToUpdate
) => TaskDetailToUpdate = (originalTaskDetail, newTaskDetail) => {
  const {
    startDate: originalStartDate,
    endDate: originalEndDate,
    completedDate: originalCompletionDate,
    ...restOfOriginalTaskDetail
  } = originalTaskDetail;
  const {
    startDate: newStartDate,
    dueDate: newEndDate,
    completionDate: newCompletionDate,
    assignees,
    ...restOfTaskDetail
  } = newTaskDetail;
  const difference = getDifference(restOfTaskDetail, restOfOriginalTaskDetail);

  if (compareDates(originalStartDate, newStartDate)) {
    difference.startDate = newStartDate;
  }

  if (compareDates(originalEndDate, newEndDate)) {
    difference.dueDate = newEndDate;
  }

  if (compareDates(originalCompletionDate, newCompletionDate)) {
    difference.completionDate = newCompletionDate;
  }

  if (assignees) {
    if (assignees.toAdd.length > 0) {
      if (!difference.assignees) {
        difference.assignees = {};
      }
      difference.assignees.toAdd = assignees.toAdd;
    }

    if (assignees.toRemove.length > 0) {
      if (!difference.assignees) {
        difference.assignees = {};
      }
      difference.assignees.toRemove = assignees.toRemove;
    }
  }

  difference.id = originalTaskDetail.id!;

  return difference as TaskDetailToUpdate;
};

export const validateRequiredTaskFields: (
  taskDetail: TaskDetailToUpdate,
  hasAssignedUsers: boolean,
  taskAssigneeDateRestriction?: boolean
) => Map<string, boolean> = (
  taskDetail,
  hasAssignedUsers,
  taskAssigneeDateRestriction = true
) => {
  const errorsMap = new Map<string, boolean>();
  if (!taskDetail.name || taskDetail.name === '') {
    errorsMap.set('name', true);
  }

  if (hasAssignedUsers && taskAssigneeDateRestriction) {
    if (!taskDetail.startDate || !taskDetail.dueDate) {
      errorsMap.set('startDate', true);
    }
  }

  if (
    taskDetail.status === TASK_STATUS.COMPLETED &&
    !taskDetail.completionDate
  ) {
    errorsMap.set('completionDate', true);
  }

  return errorsMap;
};

export const validateIfTaskDueDateIsPast = (dueDate?: string) => {
  if (dueDate) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dueDateObj = new Date(dueDate);
    dueDateObj.setHours(0, 0, 0, 0);

    return dueDateObj.getTime() < today.getTime();
  }
  return false;
};
